$(function(){
  $('#toggle').click(function(){
  	if ($('#menu').hasClass('expanded')) {
  		$('#menu.expanded').removeClass('expanded').slideToggle();
			$(this).removeClass('open');
  	} else {
    	$('#menu').addClass('expanded').slideToggle();
			$(this).addClass('open');
    }
    return false;
  });
  $(window).resize(function(){
    var win = $(window).width();
    var p = 568;
    if(win > p){
      $('#menu').show();
    } else {
      $('#menu').hide();
    }
  });

  // 2021.01.04 追加
  $('.js-toggle-menu').on('click', function(e){
    e.preventDefault();
    if ($(this).next().hasClass('expanded')) {
  		$(this).next().removeClass('expanded').slideToggle();
			$(this).removeClass('open');
  	} else {
    	$(this).next().addClass('expanded').slideToggle();
			$(this).addClass('open');
    }
    return false;
  })
});
